import type { SearchCondition } from '@/store/orderSlice/types'
import type { ORDER_STATUS_MAP } from '@/containers/Order/Index/constant'
import { isEqual, omit, pickBy } from 'lodash'
import type { ISearchFormValues } from '@/containers/Order/Index/components/SearchForm'

export const validateDataValue = (options: {
  searchConditions: Record<ORDER_STATUS_MAP, SearchCondition[]>
  name: string
  oldName: string
  formValues: ISearchFormValues
  isEdit: boolean
  activeKey: ORDER_STATUS_MAP
}) => {
  const conditions: SearchCondition[] = []
  const { searchConditions, name, oldName, formValues, isEdit, activeKey } = options
  const curConditions = searchConditions?.[activeKey] || []
  let newCondition = pickBy(formValues, Boolean)

  // 时间范围（dateGroupRange）和时间类型（dateGroupType）是一起保存，没有时间范围，也不保存时间类型
  if (!newCondition.dateGroupRange) {
    newCondition = omit(newCondition, ['dateGroupType'])
  }
  for (const item of curConditions) {
    if (isEdit && oldName === item.name) {
      conditions.push({
        name,
        condition: newCondition,
      })
    } else {
      // 如果当前筛选条件与其他筛选条件一样，校验不通过，不能保存
      if (isEqual(item.condition, newCondition)) return false
      conditions.push({
        name: item.name,
        condition: {
          ...item.condition,
        },
      })
    }
  }
  if (!isEdit) {
    conditions.push({
      name,
      condition: newCondition,
    })
  }
  return {
    ...(searchConditions || {}),
    [activeKey]: conditions,
  }
}
